import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { AlertCircle, Mail, ArrowLeft, CheckCircle } from 'lucide-react';

function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const res = await fetch('https://anchorpals.com/api/auth/forgot-password', {
        method: 'POST', headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({ email })
      });
      const data = await res.json();
      if (data.success) setSuccess(true);
      else setError(data.error?.message || 'Failed to send reset email');
    } catch (err) { setError('Network error. Please try again.'); }
    finally { setLoading(false); }
  };
  if (success) return (
    <div style={{minHeight:'100vh',display:'flex',alignItems:'center',justifyContent:'center',background:'#f5f5f7',padding:'20px'}}>
      <div style={{background:'#fff',borderRadius:'20px',padding:'40px',maxWidth:'400px',width:'100%',textAlign:'center',boxShadow:'0 4px 20px rgba(0,0,0,0.08)'}}>
        <CheckCircle size={48} color="#34c759" style={{marginBottom:'16px'}} />
        <h2 style={{margin:'0 0 12px',color:'#1d1d1f'}}>Check Your Email</h2>
        <p style={{color:'#86868b',marginBottom:'24px'}}>If an account exists for {email}, you will receive a password reset link.</p>
        <Link to="/login" style={{color:'#0071e3',textDecoration:'none',fontWeight:'500'}}>Back to Login</Link>
      </div>
    </div>
  );
  return (
    <div style={{minHeight:'100vh',display:'flex',alignItems:'center',justifyContent:'center',background:'#f5f5f7',padding:'20px'}}>
      <div style={{background:'#fff',borderRadius:'20px',padding:'40px',maxWidth:'400px',width:'100%',boxShadow:'0 4px 20px rgba(0,0,0,0.08)'}}>
        <Link to="/login" style={{display:'flex',alignItems:'center',gap:'8px',color:'#0071e3',textDecoration:'none',marginBottom:'24px'}}><ArrowLeft size={20}/> Back to Login</Link>
        <h1 style={{margin:'0 0 8px',fontSize:'28px',color:'#1d1d1f'}}>Reset Password</h1>
        <p style={{color:'#86868b',marginBottom:'24px'}}>Enter your email and we will send you a reset link.</p>
        {error && <div style={{background:'#fff2f2',border:'1px solid #ffccc7',borderRadius:'12px',padding:'12px',marginBottom:'16px',display:'flex',alignItems:'center',gap:'8px'}}><AlertCircle size={18} color="#ff3b30"/><span style={{color:'#ff3b30',fontSize:'14px'}}>{error}</span></div>}
        <form onSubmit={handleSubmit}>
          <div style={{marginBottom:'16px'}}>
            <label style={{display:'block',marginBottom:'8px',fontWeight:'500',color:'#1d1d1f'}}>Email</label>
            <div style={{position:'relative'}}>
              <Mail size={18} style={{position:'absolute',left:'14px',top:'50%',transform:'translateY(-50%)',color:'#86868b'}} />
              <input type="email" value={email} onChange={(e)=>setEmail(e.target.value)} required placeholder="your@email.com" style={{width:'100%',padding:'14px 14px 14px 44px',border:'1px solid #d2d2d7',borderRadius:'12px',fontSize:'16px',outline:'none',boxSizing:'border-box'}} />
            </div>
          </div>
          <button type="submit" disabled={loading} style={{width:'100%',padding:'14px',background:loading?'#86868b':'#0071e3',color:'#fff',border:'none',borderRadius:'12px',fontSize:'16px',fontWeight:'600',cursor:loading?'not-allowed':'pointer'}}>{loading ? 'Sending...' : 'Send Reset Link'}</button>
        </form>
      </div>
    </div>
  );
}
export default ForgotPasswordPage;
